import { render, staticRenderFns } from "./SimpleSearchBar.vue?vue&type=template&id=5950470c&scoped=true"
import script from "./SimpleSearchBar.vue?vue&type=script&lang=js"
export * from "./SimpleSearchBar.vue?vue&type=script&lang=js"
import style0 from "./SimpleSearchBar.vue?vue&type=style&index=0&id=5950470c&prod&scoped=true&lang=css"
import style1 from "./SimpleSearchBar.vue?vue&type=style&index=1&id=5950470c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950470c",
  null
  
)

export default component.exports